import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Signin } from "./Routes/Auth/Signin";
import { Signup } from "./Routes/Auth/Signup";
import { Home } from "./Routes/Home/Home";
import { NotFound } from "./Routes/NotFound/NotFound";
import { AuthContext } from "./components/Context/AuthContext";
import { Protected } from "./Routes/Protected";
import { Dispatchers } from "./Routes/Dispatchers/Dispatchers";
import { Engineers } from "./Routes/Engineers/Engineers";
import { AddRequest } from "./components/Request/AddRequest";
import { OpenedRequest } from "./Routes/OpenedRequest/OpenedRequest";
import { UpdateOpenRequest } from "./Routes/OpenedRequest/UpdateOpenRequest";
import { ClosedRequest } from "./Routes/ClosedRequest/ClosedRequest";
import { UpdateClosedRequest } from "./Routes/ClosedRequest/UpdateClosedRequest";
import { Search } from "./Routes/Search/Search";
import { UpdateSearch } from "./Routes/Search/UpdateSearch";
import { Profile } from "./Routes/Profile/Profile";
import { Switch } from "./Routes/Switch/Switch";
import { UpdateSwitch } from "./Routes/Switch/UpdateSwitch";

function App (){

  const router = createBrowserRouter([
    {
      path:"/",
      element:<Protected><Home /></Protected>,
      children: [
        { path:"/addRequest", element:<AddRequest /> },
        { path:"/openedRequest", element:<OpenedRequest /> },
        { path:"/openedRequest/:openRequestID", element:<UpdateOpenRequest /> },
        { path:"/closedRequest", element:<ClosedRequest /> },
        { path:"/closedRequest/:closeRequestID", element:<UpdateClosedRequest /> },
        { path:"/search", element:<Search /> },
        { path:"/search/:searchRequestID", element:<UpdateSearch /> },
        { path:"/dispatchers", element:<Dispatchers /> },
        { path:"/engineers", element:<Engineers /> },
        { path:"/profile", element:<Profile /> },
        { path:"/switch", element:<Switch /> },
        { path:"/switch/:switchID", element:<UpdateSwitch /> }
      ],
    },
    {
      path:"/signin",
      element:<Signin />
    },
    {
      path:"/signup",
      element:<Signup />
    },
    {
      path:"*",
      element:<NotFound />
    }
  ])

  return (
    <AuthContext>
      <RouterProvider 
        router={router}
      />
    </AuthContext>
    
  )
}  

export default App;